import { View, Text, StyleSheet } from '@react-pdf/renderer';
import { theme } from '../theme';

const style = StyleSheet.create({
  pdfDetailsRowStyle: {
    display: 'flex',
    flexDirection: 'row',
    alignContent: 'center',
    justifyContent: 'space-between',

    padding: '4px',
    borderBottom: `1px solid ${theme.colors.primaryK1}`,
  },
  pdfDetailsRowLabelStyle: {
    color: theme.colors.primaryK7,
    fontWeight: 'bold',
  },
  pdfAccentedStyle: {
    color: theme.colors.primaryK10,
    fontWeight: 'bold',
  },
});

export const PdfDetailsRow: React.FC<{
  label: string;
  value?: string | number;
  accented?: boolean;
}> = ({ label, value, accented }) => (
  <View style={style.pdfDetailsRowStyle}>
    <Text
      style={[
        style.pdfDetailsRowLabelStyle,
        accented ? style.pdfAccentedStyle : {},
      ]}>
      {label}
    </Text>
    <Text style={accented ? style.pdfAccentedStyle : {}}>{value}</Text>
  </View>
);
